import { computed, ref } from 'vue';
import type { AffiliateNetworkListItem } from '@/services/api/affiliate-networks-api';

export type AffiliateNetworksCacheState = {
  data: AffiliateNetworkListItem[];
  isUploaded: boolean;
};

export const createAffiliateNetworksCacheModule = () => {
  const affiliateNetworksCache = ref<AffiliateNetworksCacheState>({
    data: [],
    isUploaded: false,
  });

  const populateAffiliateNetworksCache = (payload: AffiliateNetworkListItem[]) => {
    affiliateNetworksCache.value.data = payload;
    affiliateNetworksCache.value.isUploaded = true;
  };

  const resetAffiliateNetworksCache = () => {
    affiliateNetworksCache.value = {
      data: [],
      isUploaded: false,
    };
  };

  const affiliateNetworksObject = computed(() =>
    affiliateNetworksCache.value.data.reduce<Record<string, AffiliateNetworkListItem>>(
      (accumulator, item) => {
        accumulator[item.id] = item;
        return accumulator;
      },
      {},
    ),
  );

  const reset = () => {
    resetAffiliateNetworksCache();
  };

  return {
    state: {
      affiliateNetworksCache,
      populateAffiliateNetworksCache,
      resetAffiliateNetworksCache,
      affiliateNetworksObject,
    },
    reset,
  };
};
